// extracted by mini-css-extract-plugin
module.exports = {"content":"OpinionsTable_content__1vYy7"};